import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  addPractitionerNote,
  getPractitionerPresciptionHistory,
  getRefillRequests,
} from "../../actions/prescriptionAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { formatDate } from "../../utils/helper";
const NotePopup = ({ closePopup, previousNote, prescriptionId }) => {
  const dispatch = useDispatch();
  const [noteContent, setNoteContent] = useState(previousNote);
  const [showAddSection, setShowAddSection] = useState(true);

  const initialValues = {
    note: previousNote.note,
  };

  const validationSchema = Yup.object({
    note: Yup.string().nullable().required("Required"),
  });
  const onSubmit = (values) => {
    dispatch(
      addPractitionerNote(noteContent.prescriptionId, values.note, () => {
        closePopup(true);
        dispatch(getRefillRequests());
        dispatch(getPractitionerPresciptionHistory());
      })
    );
    let newNote = noteContent;
    newNote.note = values.note;
    newNote.date = `${formatDate(new Date())}`;
    setNoteContent(newNote);
    setShowAddSection(false);
  };
  return (
    <Modal size="xl" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Prescription Note</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          {noteContent.note ? (
            <>
              <h4>{formatDate(noteContent.date)}</h4>
              <p className="page-desc">{noteContent.note}</p>
            </>
          ) : (
            <p className="page-desc">No Note</p>
          )}

          {showAddSection ? (
            <div>
              {" "}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ errors, touched }) => {
                  return (
                    <Form>
                      <div className="row">
                        <div className="col-sm-12">
                          <FormikControl
                            control="textarea"
                            label="Note: "
                            name="note"
                            rows="4"
                            placeholder="Enter Note about prescription here"
                            hasError={errors.note && touched.note}
                          />
                        </div>
                        <div className="action-btn-wrapper row ml-3">
                          <button
                            className="btn-orange btn-table"
                            type="submit"
                          >
                            {" "}
                            Save
                          </button>
                          {/* <button
                            className="btn-orange btn-table btn-black"
                            onClick={() => setShowAddSection(false)}
                          >
                            {" "}
                            Cancel
                          </button> */}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          ) : // ) : (
          //   <>
          //     {noteContent.note ? (
          //       <button
          //         className="btn-orange btn-table"
          //         onClick={() => setShowAddSection(true)}
          //       >
          //         Edit
          //       </button>
          //     ) : (
          //       <button
          //         className="btn-orange btn-table"
          //         onClick={() => setShowAddSection(true)}
          //       >
          //         Add
          //       </button>
          //     )}
          //   </>
          //
          null}
        </>
      </Modal.Body>
    </Modal>
  );
};
export default NotePopup;
